import * as React from "react";
import { Slot } from "@radix-ui/react-slot";

import { navRowClasses } from "@/lib/surface-styles";

export type NavRowProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  isSelected?: boolean;
  asChild?: boolean;
};

/** Sidebar / inbox navigation row — shared hover, focus, and selected chrome. */
export const NavRow = React.forwardRef<HTMLButtonElement, NavRowProps>(
  function NavRow(
    { isSelected, className, asChild = false, type, ...props },
    ref,
  ) {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp
        ref={ref}
        type={asChild ? undefined : (type ?? "button")}
        className={navRowClasses(isSelected, className)}
        {...props}
      />
    );
  },
);
NavRow.displayName = "NavRow";
